@switch (protectionState) {
  @case ('content') {
    <ng-content></ng-content>
  }
  @case ('unauthorized') {
    <app-unauthorized-page />
  }
  @case ('forbidden') {
    <app-forbidden-page />
  }
  @case ('pending-organization') {
    <app-forbidden-page [title]="'pendingOrganization.title'" [message]="'pendingOrganization.message'" />
  }
}
